import { useContext } from "react";
import { useParams } from "react-router-dom";
import { getByIds } from "sprint-common-web";

import { DistributionListsDataContent } from "../../../../../common/data/lookup-data-providers/DistributionListsDataProvider";
import { DeliveryEndpointType } from "../../../../../common/types/DeliveryEndpointType";
import { useAdminDeliveryEndpointApi } from "../../../api/useAdminDeliveryEndpointApi";
import { DeliveryEndpointContext } from "../../../context/DeliveryEndpointContext";
import { CreateDeliveryEndpointFormInputs } from "./CreateSmartjogDeliveryEndpointForm";

export const useCreateDeliveryEndpointForm = () => {
    const { createDeliveryEndpoint } = useAdminDeliveryEndpointApi();

    const { addSmartjogDeliveryEndpointItem } = useContext(DeliveryEndpointContext);
    const { distributionLists } = useContext(DistributionListsDataContent);

    const { integratorId } = useParams<{ integratorId: string }>();

    const addDeliveryEndpoint = async ({
        name,
        distributionListIds
    }: CreateDeliveryEndpointFormInputs): Promise<void> => {
        const parsedDistributionListIds = distributionListIds.map((item) => Number(item));

        const currentDistributionLists = getByIds(distributionLists, parsedDistributionListIds);

        const { entityId } = await createDeliveryEndpoint({
            integratorId,
            name,
            type: DeliveryEndpointType.Smartjog,
            distributionLists: currentDistributionLists.map((item) => ({ id: item.id, name: item.name }))
        });

        addSmartjogDeliveryEndpointItem({
            id: entityId,
            name,
            details: { distributionLists: currentDistributionLists, type: DeliveryEndpointType.Smartjog },
            type: DeliveryEndpointType.Smartjog,
            updatedDate: new Date().toISOString()
        });
    };

    return {
        distributionLists,
        addDeliveryEndpoint
    };
};
